import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { NotificationEnce } from '../../interfaces/NotificationEnce.interface';
import { Client } from '../../interfaces/Client.interface';

declare var $ : any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  providers:[LoginService]
})
export class FooterComponent implements OnInit {

  public modal1:boolean;
  public modal2:boolean;
  public modal3:boolean;
  public modalOffer:boolean;
  public listOffer:Array<NotificationEnce>;
  public infuser: Client;

  constructor(private _loginService:LoginService) { 
    this.listOffer = [];
  }

  ngOnInit() {
    
    this.getOfferModal();
    this.infuser=JSON.parse(localStorage.getItem('infoClient'));
  }

  public loadModal(type){
    if(type===1){
      this.modal1=true;
      this.modal2=false;
      this.modal3=false;
      this.modalOffer=false;
    }else if(type===2){
      this.modal1=false;
      this.modal2=true;
      this.modal3=false;
      this.modalOffer=false;
    }else if(type===3){
      this.modal1=false;
      this.modal2=false;
      this.modal3=true;
      this.modalOffer=false;
    }
  }

  public getOfferModal(){
    this._loginService.getOfferClient().subscribe(
        response => {
          if(response.empty===false){
            this.modal1=false;
            this.modal2=false;
            this.modal3=false;
            this.modalOffer=true;
            this.listOffer=response.list;
            console.log('OFERTAS CALL '+JSON.stringify(this.listOffer));
            localStorage.setItem('notifications',JSON.stringify(this.listOffer));

            $('#exampleModal').modal('toggle');
          }else{
            this.modalOffer=false;
          }
          
        },
        error => {
            console.error('Error'+error);
        }
    );
}

}
